<template>
  <additional-information :data="data" :currency="currency"></additional-information>
</template>

<script>
// "Informazioni aggiuntive" (AdditionalInfo), IBIPs-only, typed payload (~50 scalars +
// ExitCostsTunnelData list — not a field-catalog section). Reuses
// components/DIP/AdditionalInformation.vue + dip/configuration.js (prop-driven, no
// Vuex/parent coupling) — a substantial declarative field composer
// (component-per-field-type, conditional visibility by premiumType/productType, minMax/slider/table
// renderers).
//
// AdditionalInformation.vue/dip/configuration.js are entirely keyed by 'Ai'-prefixed
// field names (aiCap, aiRedeemTerm, ...) — the AdditionalInfoPayload deliberately omits that
// prefix, so this adapter's only real job is adding it: `toAiPrefixed` renames every
// key `xxx` to `aiXxx`, values untouched (including the ExitCostsTunnelData array itself — its own
// item shape, {from, to, value}, is unaffected, only the container key is renamed to
// aiExitCostsTunnelData). The transform is uniform across all ~50 fields (every
// entry in dip/configuration.js's FIELDS_COMPOSER/VISIBILITY_RULES). i18n labels need no
// extra keys — AdditionalInformation.vue resolves them itself off the
// productDetails.DIP.additionalInformation.<aiKey> messages.
//
// productInfo.premiumType/productType (needed by VISIBILITY_RULES to conditionally show fields, e.g.
// aiPremiumAmountAnnual only for a Regular/Mixed premium type) are NOT part of AdditionalInfoPayload
// — read via the shared detailPage inject (characteristicField(), see ProductDetails.vue). Sidebar
// Characteristics projects these as the .NET enum MEMBER NAME (DetailFieldProjectorRegistry calls
// .ToString() explicitly), e.g. "RamoI"/"Single" — but
// dip/configuration.js's VISIBILITY_RULES compares against raw numeric codes
// (PremiumType/ProductType's own C# enum values), so *_NUMBER_BY_NAME below converts back. This is
// the opposite direction from AdditionalInfoPayload's own enum fields (InsuranceLifeType,
// SplitPremiumPeriod, ...), which are NOT part of the field-catalog projector system and therefore
// serialize as plain numbers by default (no JsonStringEnumConverter registered anywhere in the app)
// — exactly the shape isValueOf/enumOptions already expect, so those
// need no conversion at all.
import AdditionalInformation from '../../DIP/AdditionalInformation'

function toAiPrefixed(payload) {
  const out = {}
  Object.keys(payload).forEach((key) => {
    out['ai' + key.charAt(0).toUpperCase() + key.slice(1)] = payload[key]
  })
  return out
}

// PremiumType/ProductType (OpenKid.Model) — numeric codes dip/configuration.js's VISIBILITY_RULES
// was written against, mapped from the .NET enum member name Sidebar/Characteristics projects.
const PREMIUM_TYPE_NUMBER_BY_NAME = { Single: 1, Regular: 2, Mixed: 3 }
const PRODUCT_TYPE_NUMBER_BY_NAME = { RamoI: 1, RamoIII: 2, MultiRamo: 3, RamoV: 4 }

export default {
  name: 'additional-info-section',
  components: {
    AdditionalInformation,
  },
  inject: ['detailPage'],
  props: {
    payload: { type: Object, required: true },
  },
  computed: {
    currency() {
      return this.detailPage.currency
    },
    data() {
      return {
        additionalInfo: toAiPrefixed(this.payload),
        productInfo: {
          premiumType: PREMIUM_TYPE_NUMBER_BY_NAME[this.detailPage.characteristicField('premiumType')] || null,
          productType: PRODUCT_TYPE_NUMBER_BY_NAME[this.detailPage.characteristicField('productType')] || null,
        },
      }
    },
  },
}
</script>
